// import * as apis from '@apis'
const live = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'nis-live'
    },
    liveItemMetadata: {
      'mod': 'nis-liveitem'
    }
  },
  getters: {},
  mutations: {
  },
  actions: {}
}

export default live
